// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__KFz9-","content":"FallbackPage_content__utpw-"};